import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchChart } from './dashboardChartSlice'
import ChartSelectBox from './ChartSelectBox'
import Loading from 'components/loading/Loading'
import Chart from './Chart'
import { DashboardInfoTypes } from 'features/Codes'

const DashboardChart = () => {
  const dispatch = useDispatch()
  const {
    info: { type, id },
    common: { from, to },
    chart: { isLoading },
    filter: { filters },
    table: {
      campaignTable: { selectedIds: campaignIds },
      adGroupTable: { selectedIds: adGroupIds },
    },
  } = useSelector(state => state.dashboard)

  useEffect(() => {
    if (type === DashboardInfoTypes.AD_ACCOUNT) {
      dispatch(fetchChart())
    }
  }, [dispatch, type, from, to])

  useEffect(() => {
    if (
      [
        DashboardInfoTypes.CAMPAIGN,
        DashboardInfoTypes.AD_GROUP,
        DashboardInfoTypes.KEYWORD,
        DashboardInfoTypes.CREATIVE,
      ].includes(type)
    ) {
      dispatch(fetchChart())
    }
  }, [dispatch, type, from, to, id])

  useEffect(() => {
    if (type === DashboardInfoTypes.TOTAL_CAMPAIGN) {
      dispatch(fetchChart())
    }
  }, [dispatch, type, from, to, filters])

  useEffect(() => {
    if (type === DashboardInfoTypes.TOTAL_AD_GROUP) {
      dispatch(fetchChart())
    }
  }, [dispatch, type, from, to, filters, campaignIds])

  useEffect(() => {
    if (
      [
        DashboardInfoTypes.TOTAL_KEYWORD,
        DashboardInfoTypes.TOTAL_CONTENT_MATCHING,
        DashboardInfoTypes.TOTAL_CREATIVE,
      ].includes(type)
    ) {
      dispatch(fetchChart())
    }
  }, [dispatch, type, from, to, filters, campaignIds, adGroupIds])

  return (
    <>
      <div className="boxcard_select">
        <ChartSelectBox icon={<span className="ico_on on_b" />} index={0} />
        <ChartSelectBox icon={<span className="ico_on" />} index={1} />
        <ChartSelectBox index={2} />
        <ChartSelectBox index={3} />
      </div>
      <div className="graph_wrap">
        {isLoading ? (
          <div style={{ height: 259 }}>
            <Loading />
          </div>
        ) : (
          <Chart />
        )}
      </div>
    </>
  )
}
export default DashboardChart
